import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import "./App.css";
import { Toaster } from "react-hot-toast";
import PublicRoutes from "./routes/PublicRoutes";
import StudentRoutes from "./routes/StudentRoutes";
import AdminRoutes from "./routes/AdminRoutes";
import StudentLayout from "./layouts/StudentLayout";
import AdminLayout from "./layouts/AdminLayout";
import { PrivateProvider } from "./contexts/PrivateContext";
import { LevelTestProvider } from "./contexts/LevelTestContext";
import { AppInsightsRouteTracker } from "./telemetry/AppInsightsRouteTracker";
import { RouteBehaviorTracker } from "./telemetry/RouteBehaviorTracker";

function App() {
  return (
    <PrivateProvider>
      <LevelTestProvider>
        <Router>
          <AppInsightsRouteTracker />
          <RouteBehaviorTracker />
          <Toaster />
          <Routes>
          {/* Public Routes */}
          <Route path="/*" element={<PublicRoutes />} />

          {/* Student Routes */}
          <Route path="/student" element={<StudentLayout />}>
            <Route index element={<Navigate to="/student/level-test" replace />} />
            <Route path="*" element={<StudentRoutes />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="*" element={<AdminRoutes />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/home" />} />
        </Routes>
        </Router>
      </LevelTestProvider>
    </PrivateProvider>
  );
}

export default App;
